import { useCallback, useContext } from 'react';
import { FormGroup } from 'reactstrap';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { httpClient } from '@s20/services/httpClient';
import { FormContext, FormLabel, toasty } from '../../../common/forms/FormElements';
import FileUpload from '../../../common/forms/FileUpload';
import { ApiRoutes, SupportedFileExtensionString } from '../../../Common';

export const Attachments = () => {
    const { values, setFieldValue } = useContext(FormContext);
    const { tempSessionId, uploads } = values;

    const queryClient = useQueryClient();

    const { data: attachments } = useQuery({
        queryKey: ['attachments', tempSessionId],
        queryFn: () => httpClient.get(
            ApiRoutes.job.getAllAttachments(tempSessionId),
        ),
    });

    const handleAttachmentAdd = useMutation({
        mutationFn: (newFile) => [...uploads || [], newFile],
        onSuccess: (uploads) => {
            queryClient.invalidateQueries({ queryKey: ['attachments', tempSessionId] });
            setFieldValue('uploads', uploads);
        },
    });

    const handleAttachmentRemove = useMutation({
        mutationFn: async (file) => {
            const url = ApiRoutes.job.attachment(tempSessionId);

            await httpClient.delete(url, file, httpClient.format.json);

            return (uploads || [])
                .filter((f) => f.name !== file.name);
        },
        onSuccess: (uploads) => {
            queryClient.invalidateQueries({ queryKey: ['attachments', tempSessionId] });
            setFieldValue('uploads', uploads);

            toasty.success('Attachment removed successfully');
        },
    });

    const handleAttachmentDownload = useCallback(async (file) => {
        if (!file) return;

        const url = ApiRoutes.job.attachment(tempSessionId);
        await httpClient.downloadFile(url, file, file.name);
    }, [tempSessionId]);

    return (
        <FormGroup>
            <FormLabel
                text={(
                    <>
                        Attach Files

                        <small className="text-muted d-block mt-1">
                            Max 40MB | Supported: {SupportedFileExtensionString}
                        </small>
                    </>
                )}
            />

            <FileUpload
                id="jobUploader"
                accept={SupportedFileExtensionString}
                maxNameLength={150}
                url={ApiRoutes.job.postAttachments(tempSessionId)}
                onUploadComplete={handleAttachmentAdd.mutate}
                files={attachments}
                onDownload={handleAttachmentDownload}
                onDelete={handleAttachmentRemove.mutateAsync}
            />
        </FormGroup>
    );
};